import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ProjectDetail from "./pages/ProjectDetail";
import Journal from "./pages/Journal";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import { Toaster } from "sonner";

function App() {
  return (
    <BrowserRouter>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/work/:slug" element={<ProjectDetail />} />
        <Route path="/journal" element={<Journal />} />
      </Routes>
      <Footer />
      <Toaster position="bottom-right" theme="dark" />
    </BrowserRouter>
  );
}

export default App;
